import ReportServices from "@/services/ReportServices.js";
import WarehouseServices from "@/services/WarehouseServices.js";

export default {
  getTransaction: ReportServices.getTransaction,
  getWarehouseList: WarehouseServices.getList
}